import axios from "axios";

declare global {
  interface Window {
    config: {
      ssoApiUrl: any;
      tseApiUrl: any;
      clientID: any;
      notifyApiUrl: any;
      signalRUrl: any;
      sessionTimeOut: any;
      helpLink: any;
      sessionTimeOutAlert: number;
      usmApiUrl: any;
      opfUrl: any;
    };
  }
}

console.log(window);

export const SSOApi = axios.create({
  baseURL: window.config.ssoApiUrl,
  headers: {
    "Content-type": "application/json",
  },
});

export const TSEApi = axios.create({
  baseURL: window.config.tseApiUrl,
  headers: {
    "Content-type": "application/json",
  },
});

export const NotifyApi = axios.create({
  baseURL: window.config.notifyApiUrl,
  headers: {
    "Content-type": "application/json",
  },
});

export const UsmApi = axios.create({
  baseURL: window.config.usmApiUrl,
  headers: {
    "Content-type": "application/json",
  },
});

export const OpfUrl = axios.create({
  baseURL: window.config.opfUrl,
  headers: {
    "Content-type": "application/json",
  },
});

const getToken = () => sessionStorage.getItem("sso-token");
const onUnauthorized = () => {
  sessionStorage.clear();
  window.location.href = "/login"; 
};

const requestInterceptor = (config: any) => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

const requestErrorInterceptor = (error: any) => Promise.reject(error);

const responseErrorInterceptor = (error: any) => {
  if (error.response?.status === 401) {
    onUnauthorized();
  }
  return Promise.reject(error);
};

const responseInterceptor = (response: any) => response;

[SSOApi, NotifyApi].forEach((instance) => {
  instance.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
  instance.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
});